import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import { updateAuth } from "../../Redux/AuthSlice";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import "./Tree_View.css";
import { toast } from "react-toastify";
import TreeHoverNode from "./TreeHoverNode";
import DOMPurify from "dompurify";
import user3red from "./TreeImage/redicon.png";
import Default from "./TreeImage/blackicon.png";
import Active from "./TreeImage/greenicon.png";
import SidebarFIX from "../Sidebar/SidebarFIX";

var bol = true;
export default function MatchingTreeFIX() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dash, setdataArray] = useState([]);
  const { userId, jwtToken } = useSelector((state) => state.Auth);

  const GetUserDetails = async () => {
    try {
      let responceDash = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 1,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      console.log("responceDashboard", responceDash.data.data[0]);
      responceDash = responceDash.data.data[0];

      setdataArray(responceDash);
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const user = useSelector((state) => state.Auth.userId);
  const jwt = useSelector((state) => state.Auth.jwtToken);
  // console.log("User",user);

  const [Idnumer, setIdnumer] = useState(user);
  const [arrValue, setArrValue] = useState([]);
  const [getValue, setgetValue] = useState("");
  const [loader, setloader] = useState(false);
  const [searchvalue, setsearchvalue] = useState(0);

  const [userdata, setuserdata] = useState([
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "0",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
    {
      name: "",
      id: "",
      registration_date: "",
      status: "",
      total_left: "",
      total_left_active: "",
      left_business: "",
      package_amount: "",
      Activation_date: "",
      package: "",
      total_right: "",
      total_right_active: "",
      right_business: "",
      Sponsor: "",
      PackId:0
    },
  ]);
  const referral_API = async () => {
    try {
      let responce = await API?.post(
        "/binaryTree_Fix",
        {
          searchId: Idnumer,
          loginId: user,
        },
        {
          headers: {
            Authorization: `${jwt}`,
            "Content-Type": "application/json", // Adjust the content type as needed
          },
        }
      );
      responce = responce?.data?.data[0];
      console.log("Res_API_binaryTree", responce);
      if (responce == undefined) {
        toast.error("User ID Not Found");
        setloader(false);
      } else {
        setloader(true);

        let arr = [];
        responce.forEach((item, index) => {
          arr.push({
            name: item.fname,
            id: item.uid,
            registration_date: String(item?.Regdate).substring(0, 12),
            status: item.activationdate ? "Active" : "InActive",
            total_left: item.T_Left,
            total_left_active: item.totalleft,
            left_business: item.lbv,
            package_amount: item.T_package,
            Activation_date: String(item.activationdate).substring(0, 12),
            package: item.packageamount,
            total_right: item.T_Right,
            total_right_active: item.totalright,
            right_business: item.rbv,
            Sponsor: item.sid,
            date: item?.packageName,
            PackId: item?.package,
            today_left_business: item.T_LeftB,
            today_right_business: item.T_RightB,
            // left_carry_forward: item.carryleft,
            // right_carry_forward: item.carryright,
            // rank: item.rewardrankname,
          });
        });
        // console.log("responce", arr);

        // setloader(false);

        setuserdata(arr);
        if (bol) {
          setArrValue([...arrValue, arr[0].id]);
          bol = false;
        }
      }
    } catch (e) {
      // setloader(false);
      console.log("Error While calling Referrer API", e);
    }
  };
  function addValue(value) {
    setArrValue([...arrValue, value]);
    // arrValue.push(value)
    // arrValue.push(value)
  }

  var a;
  function popoutvalue() {
    if (arrValue.length == 1) {
      // setloader(true)
      arrValue.pop();
      arrValue.unshift(user);
      bol = true;
    } else {
      a = arrValue.splice(arrValue.length - 2, 1);
      setIdnumer(a[0]);
    }
  }

  const GotoHome = () => {
    navigate("/DashBoardBOT");
  };

  useEffect(() => {
    GetUserDetails();
    referral_API();
    let idinput = document.querySelector(".idinput");
    idinput.value = Idnumer;
  }, [Idnumer]);
  // togglar

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarFIX />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
              <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FIX Investment
                  </Link>
                  {dash?.Fixpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ALGO TRADING Investment
                  </Link>
                  {dash?.FixTradingpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ADV. TRADING Investment
                  </Link>
                  {dash?.FixAdvTradingpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-black walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-black walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardBOT">
                        <button className="btn headerbtn">MAGIC PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-black ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-12">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading">Matching Tree (FIX)</div>
                      <div className="" role="document">
                        <div className="col-12">
                          <div className="row mx-0 pb-5">
                            <div className="col-md-6">
                              <div className="search-box">
                                <div className="form-horizontal ng-pristine ng-valid">
                                  <div className="form-wrapper">
                                    <input
                                      className="form-control idinput srch_frm bg-white shadow-none text-black"
                                      id="ddluserid"
                                      name="userId"
                                      maxLength={8}
                                      placeholder="Search"
                                      Value={Idnumer}
                                      onChange={(e) =>
                                        setgetValue(
                                          DOMPurify.sanitize(
                                            e.target.value
                                              .replace(/[^0-9]/gi, "")
                                              .substring(0, 8)
                                          )
                                        )
                                      }
                                    />
                                    <span
                                      className="field-validation-valid"
                                      data-valmsg-for="userId"
                                      data-valmsg-replace="true"
                                    />
                                    <button
                                      id="#submit"
                                      type="button"
                                      className="btn btn-sm btn-danger topmargin submit_btn border-0 shadow-none"
                                      onClick={() => (
                                        setIdnumer(getValue), addValue(getValue)
                                      )}
                                    >
                                      Search
                                    </button>
                                    <button
                                      id="#home"
                                      type="button"
                                      className="btn btn-sm btn-danger border-0 shadow-none topmargin float_rt"
                                      //onClick={() => setIdnumer(user)}
                                      onClick={() => GotoHome()}
                                    >
                                      Home
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger shadow-none topmargin float_rt border-0"
                                      onClick={popoutvalue}
                                    >
                                      BACK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="tree_icon">
                                <div className="tree_name">
                                  <img
                                    src={Active}
                                    width="40px"
                                    height="40px"
                                  />
                                  Active
                                </div>
                                <div className="tree_name">
                                  <img
                                    src={user3red}
                                    width="40px"
                                    height="40px"
                                  />
                                  In-Active
                                </div>
                                <div className="tree_name">
                                  <img
                                    src={Default}
                                    width="40px"
                                    height="40px"
                                  />
                                  Not Registered
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 pb-5">
                          <div className="card pb-5">
                            <div className="MintingHistory_Main Mobile_MintingHistory_Main">
                              <div className="TreeImgMian ">
                                <ul class="tree vertical">
                                  <li className="kzsxjka">
                                    <div class="popover__wrapper">
                                      <a>
                                        <h2 class="popover__title">
                                          <img
                                            src={
                                              userdata[0].PackId >= 1
                                                ? Active
                                                : userdata[0].id == ""
                                                ? Default
                                                : user3red
                                            }
                                            alt="Image description"
                                            className="img-fluid"
                                            style={{ width: 60 }}
                                            onClick={() => (
                                              setIdnumer(userdata[0].id),
                                              addValue(userdata[0].id)
                                            )}
                                          />
                                        </h2>
                                        <p className="text-black text-center">
                                          {userdata[0].id}<br/>({userdata[0].name})
                                        </p>
                                      </a>
                                      <TreeHoverNode data={userdata[0]} />
                                    </div>
                                    <ul>
                                      <li>
                                        <div class="popover__wrapper">
                                          <a>
                                            <h2 class="popover__title">
                                              <img
                                                src={
                                                  userdata[1].PackId >= 1
                                                    ? Active
                                                    : userdata[1].id == ""
                                                    ? Default
                                                    : user3red
                                                }
                                                alt="Image description"
                                                className="img-fluid"
                                                style={{ width: 60 }}
                                                onClick={() => (
                                                  setIdnumer(userdata[1].id),
                                                  addValue(userdata[1].id)
                                                )}
                                              />
                                            </h2>
                                            <p className="text-black text-center">
                                              {userdata[1].id}<br/>({userdata[1].name})
                                            </p>
                                          </a>
                                          <TreeHoverNode data={userdata[1]} />
                                        </div>
                                        <ul>
                                          <li>
                                            <div class="popover__wrapper">
                                              <a>
                                                <h2 class="popover__title">
                                                  <img
                                                    src={
                                                      userdata[3].PackId >= 1
                                                        ? Active
                                                        : userdata[3].id == ""
                                                        ? Default
                                                        : user3red
                                                    }
                                                    alt="Image description"
                                                    className="img-fluid"
                                                    style={{ width: 60 }}
                                                    onClick={() => (
                                                      setIdnumer(
                                                        userdata[3].id
                                                      ),
                                                      addValue(userdata[3].id)
                                                    )}
                                                  />
                                                </h2>
                                                <p className="text-black text-center">
                                                  {userdata[3].id}<br/>({userdata[3].name})
                                                </p>
                                              </a>
                                              <TreeHoverNode
                                                data={userdata[3]}
                                              />
                                            </div>
                                            <ul>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[7].PackId >=
                                                          1
                                                            ? Active
                                                            : userdata[7].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[7].id
                                                          ),
                                                          addValue(
                                                            userdata[7].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[7].id}<br/>({userdata[7].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[7]}
                                                  />
                                                </div>
                                              </li>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[8].PackId >=
                                                          1
                                                            ? Active
                                                            : userdata[8].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[8].id
                                                          ),
                                                          addValue(
                                                            userdata[8].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[8].id}<br/>({userdata[8].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[8]}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </li>
                                          <li>
                                            <div class="popover__wrapper">
                                              <a>
                                                <h2 class="popover__title">
                                                  <img
                                                    src={
                                                      userdata[4].PackId >= 1
                                                        ? Active
                                                        : userdata[4].id == ""
                                                        ? Default
                                                        : user3red
                                                    }
                                                    alt="Image description"
                                                    className="img-fluid"
                                                    style={{ width: 60 }}
                                                    onClick={() => (
                                                      setIdnumer(
                                                        userdata[4].id
                                                      ),
                                                      addValue(userdata[4].id)
                                                    )}
                                                  />
                                                </h2>
                                                <p className="text-black text-center">
                                                  {userdata[4].id}<br/>({userdata[4].name})
                                                </p>
                                              </a>
                                              <TreeHoverNode
                                                data={userdata[4]}
                                              />
                                            </div>
                                            <ul>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[9].PackId >=
                                                          1
                                                            ? Active
                                                            : userdata[9].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[9].id
                                                          ),
                                                          addValue(
                                                            userdata[9].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[9].id}<br/>({userdata[9].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[9]}
                                                  />
                                                </div>
                                              </li>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[10]
                                                            .PackId >= 1
                                                            ? Active
                                                            : userdata[10].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[10].id
                                                          ),
                                                          addValue(
                                                            userdata[10].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[10].id}<br/>({userdata[10].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[10]}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                      </li>
                                      {/* right side of tree start here */}
                                      <li>
                                        <div class="popover__wrapper">
                                          <a>
                                            <h2 class="popover__title">
                                              <img
                                                src={
                                                  userdata[2].PackId >= 1
                                                    ? Active
                                                    : userdata[2].id == ""
                                                    ? Default
                                                    : user3red
                                                }
                                                alt="Image description"
                                                className="img-fluid"
                                                style={{ width: 60 }}
                                                onClick={() => (
                                                  setIdnumer(userdata[2].id),
                                                  addValue(userdata[2].id)
                                                )}
                                              />
                                            </h2>
                                            <p className="text-black text-center">
                                              {userdata[2].id}<br/>({userdata[2].name})
                                            </p>
                                          </a>
                                          <TreeHoverNode data={userdata[2]} />
                                        </div>
                                        <ul>
                                          <li>
                                            <div class="popover__wrapper">
                                              <a>
                                                <h2 class="popover__title">
                                                  <img
                                                    src={
                                                      userdata[5].PackId >= 1
                                                        ? Active
                                                        : userdata[5].id == ""
                                                        ? Default
                                                        : user3red
                                                    }
                                                    alt="Image description"
                                                    className="img-fluid"
                                                    style={{ width: 60 }}
                                                    onClick={() => (
                                                      setIdnumer(
                                                        userdata[5].id
                                                      ),
                                                      addValue(userdata[5].id)
                                                    )}
                                                  />
                                                </h2>
                                                <p className="text-black text-center">
                                                  {userdata[5].id}<br/>({userdata[5].name})
                                                </p>
                                              </a>
                                              <TreeHoverNode
                                                data={userdata[5]}
                                              />
                                            </div>
                                            <ul>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[11]
                                                            .PackId >= 1
                                                            ? Active
                                                            : userdata[11].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[11].id
                                                          ),
                                                          addValue(
                                                            userdata[11].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[11].id}<br/>({userdata[11].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[11]}
                                                  />
                                                </div>
                                              </li>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[12]
                                                            .PackId >= 1
                                                            ? Active
                                                            : userdata[12].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[12].id
                                                          ),
                                                          addValue(
                                                            userdata[12].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[12].id}<br/>({userdata[12].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[12]}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </li>
                                          <li>
                                            <div class="popover__wrapper">
                                              <a>
                                                <h2 class="popover__title">
                                                  <img
                                                    src={
                                                      userdata[6].PackId >= 1
                                                        ? Active
                                                        : userdata[6].id == ""
                                                        ? Default
                                                        : user3red
                                                    }
                                                    alt="Image description"
                                                    className="img-fluid"
                                                    style={{ width: 60 }}
                                                    onClick={() => (
                                                      setIdnumer(
                                                        userdata[6].id
                                                      ),
                                                      addValue(userdata[6].id)
                                                    )}
                                                  />
                                                </h2>
                                                <p className="text-black text-center">
                                                  {userdata[6].id}<br/>({userdata[6].name})
                                                </p>
                                              </a>
                                              <TreeHoverNode
                                                data={userdata[6]}
                                              />
                                            </div>
                                            <ul>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[13]
                                                            .PackId >= 1
                                                            ? Active
                                                            : userdata[13].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[13].id
                                                          ),
                                                          addValue(
                                                            userdata[13].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[13].id}<br/>({userdata[13].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[13]}
                                                  />
                                                </div>
                                              </li>
                                              <li>
                                                <div class="popover__wrapper">
                                                  <a>
                                                    <h2 class="popover__title">
                                                      <img
                                                        src={
                                                          userdata[14]
                                                            .PackId >= 1
                                                            ? Active
                                                            : userdata[14].id ==
                                                              ""
                                                            ? Default
                                                            : user3red
                                                        }
                                                        alt="Image description"
                                                        className="img-fluid"
                                                        style={{ width: 60 }}
                                                        onClick={() => (
                                                          setIdnumer(
                                                            userdata[14].id
                                                          ),
                                                          addValue(
                                                            userdata[14].id
                                                          )
                                                        )}
                                                      />
                                                    </h2>
                                                    <p className="text-black text-center">
                                                      {userdata[14].id}<br/>({userdata[14].name})
                                                    </p>
                                                  </a>
                                                  <TreeHoverNode
                                                    data={userdata[14]}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
